import { FormattedNumber } from 'react-intl';
import { PoolBadge, PoolTypography } from '@synergy/components-next';
import { ReactElement } from 'react';
import { ShoppingCartIcon } from '@synergy/theme-next';
import { Stack, styled } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import { ROUTES } from '../../../../utils/routes';
import { shoppingCartMinimalInfoSelector } from '../../../../store/shopping-cart-selectors';
import { useAppSelector } from '../../../../../store/store';

const Wrapper = styled(Stack)(({ theme }) => ({
    justifyContent: 'center',
    width: 188,
    color: theme.palette.common.white,

    '&:hover': {
        cursor: 'pointer',
        color: theme.palette.grey[700],
    },
}));

export const ShoppingCart = (): ReactElement => {
    const cartInfos = useAppSelector(shoppingCartMinimalInfoSelector);
    const navigate = useNavigate();

    return (
        <Wrapper data-testid="shopping-cart" onClick={() => navigate(ROUTES.cart.base)}>
            <Stack direction="row" justifyContent="flex-end" alignItems="center" gap={1} height={24}>
                <PoolTypography translationId="app.topNavigation.shoppingCart" variant="subtitle1" />
                {cartInfos.itemCount === 0 ? (
                    <ShoppingCartIcon fontSize="medium" />
                ) : (
                    <PoolBadge badgeContent={cartInfos.itemCount} data-testid="shopping-cart-badge" />
                )}
            </Stack>
            <PoolTypography variant="body2" sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                <FormattedNumber value={cartInfos.totalNetPrice} currency={cartInfos.currency} style="currency" />
            </PoolTypography>
        </Wrapper>
    );
};
